import React from 'react';
import { SettingsPageLayoutProps } from './types';
import { styles } from './styles';
import { Button } from '@v2/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const SettingsPageLayout: React.FC<SettingsPageLayoutProps> = ({
  icon,
  title,
  actionLabel,
  onAction,
  filters,
  children,
}) => {
  return (
    <div className={styles.container} style={{ height: 'calc(100vh - 65px)' }}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          <FontAwesomeIcon icon={icon} />
          <span>{title}</span>
        </h1>
        {actionLabel && onAction && (
          <Button
            variant="primary"
            onClick={onAction}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {actionLabel}
          </Button>
        )}
      </div>
      {filters && <div className={styles.filtersContainer}>{filters}</div>}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default SettingsPageLayout;
export type { SettingsPageLayoutProps } from './types';
